module.exports = __webpack_public_path__ + "img/card_additional_questions_egress_process.3f1cf3a1.svg";